import { Component, EventEmitter, Input, Output, ElementRef, OnChanges } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

export type IconSize = 'xs' | 'sm' | 'default' | 'l' | 'xl' | 'xxl' | 'xxxl';

@Component({
  selector: 'c-icon',
  imports: [FontAwesomeModule],
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  host: { '[class]': 'size' },
})
export class IconComponent implements OnChanges {
  @Input() icon: string | IconProp;
  @Input() color: string | undefined;
  @Input() size: IconSize = 'default';

  @Output() action: EventEmitter<any> = new EventEmitter();

  get faIcon(): IconProp {
    return this.icon as IconProp;
  }

  constructor(private elementRef: ElementRef) {}

  ngOnChanges(): void {
    if (!this.color) {
      return;
    }
    this.elementRef.nativeElement.style.setProperty('color', `var(--ion-color-${this.color})`);
  }

  isStringIcon(): boolean {
    return typeof this.icon === 'string';
  }

  onClick(event: Event): void {
    this.action.emit(event);
  }
}
